import { render, staticRenderFns } from "./ProductsWizardProvider.vue?vue&type=template&id=e204a7ce&"
import script from "./ProductsWizardProvider.vue?vue&type=script&lang=js&"
export * from "./ProductsWizardProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports